import { useTranslation } from 'next-i18next'

import BrainOrb from '~/components/BrainOrb'

export default function UpgradingScreen(): React.ReactElement {
  const { t } = useTranslation('systemUpdate')

  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center gap-6 overflow-hidden bg-purple-midnight px-4 py-8 text-white">
      <div className="flex flex-wrap items-center justify-center gap-3">
        <span className="rounded-full bg-green-light-deep/10 px-4 py-1.5 text-xxs font-extrabold uppercase tracking-px text-green-light-deep">
          {t('badge')}
        </span>
        <span aria-hidden className="block size-1.5 rounded-full bg-pink-hot" />
        <span className="text-xs font-bold text-gray-400">{t('version')}</span>
      </div>

      <BrainOrb size="lg" />

      <h1 className="bg-clip-text bg-gradient-to-r from-purple-light-top via-pink-500 to-blue-crystal text-center text-base font-extrabold leading-snug text-transparent md:text-2xl">
        {t('upgrading.title')}
      </h1>

      <div aria-hidden className="flex items-center gap-2">
        <span
          className="block size-2 animate-dot-pulse rounded-full bg-purple-medium-light"
          style={{ animationDelay: '0s' }}
        />
        <span
          className="block size-2 animate-dot-pulse rounded-full bg-purple-medium-light"
          style={{ animationDelay: '0.15s' }}
        />
        <span
          className="block size-2 animate-dot-pulse rounded-full bg-purple-medium-light"
          style={{ animationDelay: '0.3s' }}
        />
        <span
          className="block size-2 animate-dot-pulse rounded-full bg-purple-medium-light"
          style={{ animationDelay: '0.45s' }}
        />
      </div>
    </main>
  )
}
